import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    {/* <a
      href='https://github.com/colet0227'
      className='link footer__link'
    >
      Created By Cole Thompson
    </a> */}
  </footer>
)

export default Footer